const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the workflow category selection
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('workflowCategory', ['Application', 'Categories', 'Groups', '$q', '$translate', function (Application, Categories, Groups, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      startItems: '=',
      onChange: '&',
      selectionLimit: '@',
      clear: '=',
      type: '@'
    },
    template: require('../../templates/directives/workflow-category-selection.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queries = [];
      self.queryIds = {};
      self.updateQuery = function () {
        $scope.onChange({items: self.queries});
      };
      self.translations = {};

      self.given = {
        parse: function () {
          if (!$scope.startItems || !$scope.startItems.length) {
            return;
          }
          var lineage = [];
          var umbrella = {};
          for (var i = 0; i < $scope.startItems.length; i++) {
            umbrella[$scope.startItems[i].id] = true;
            lineage = lineage.concat(self.lineage.get($scope.startItems[i].id));
          }
          for (var cat in self.categories) {
            var item = self.categories[cat];
            if (umbrella[cat] === true) {
              if (!item.parent || !self.queryIds[item.parent]) {
                self.queryIds[item._id] = true;
                self.queries.push({
                  name: self.lineageName(item),
                  text: self.lineageName(item),
                  _id: item._id,
                  type: $scope.type
                });
              }
            }
          }
        }
      };
      self.lineage = {
        get: function(id) {
          var items = [id];
          var children = [];
          var grandChildren = [];

          var addTo = function(id) {
            children.push(id);
            var main = self.categories[id];
            if (!main || !main.children || !main.children.length) {
              return;
            }
            for (var i = 0; i < main.children.length; i++) {
              grandChildren.push(main.children[i]);
            }
          };

          if (!self.categories[id] || !self.categories[id].children || !self.categories[id].children.length) {
            return items;
          }

          for (var i = 0; i < self.categories[id].children.length; i++) {
            addTo(self.categories[id].children[i], children);
          }

          return items.concat(children, grandChildren);
        },
        isAncestor: function(item, set) {
          var list = this.get(item);
          var matching = [];
          for (var i = 0; i < set.length; i++) {
            if (!set[i]._id) {
              continue;
            }
            if (list.indexOf(set[i]._id) !== -1) {
              matching.push(set[i]._id);
            }
          }
          if (matching.length) {
            return matching;
          }
          return false;
        },
        isDecendent: function(item, set) {
          var list;
          var item;
          for (var i = 0; i < set.length; i++) {
            if (!set[i]._id) {
              continue;
            }
            list = this.get(set[i]._id);
            if (list.indexOf(item) !== -1) {
              item = self.categories[set[i]._id];
              if (item.parent && set.indexOf(item.parent) !== -1) {
                item = self.categories[item.parent];
              }
              return item;
            }
          }
          return false;
        }
      };

      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          var covered = {};
          var message;
          if (!$tag._id || !$tag.type || !$tag.name) {
            return false;
          }
          if ($scope.selectionLimit) {
            if (self.queries.length && self.queries.length >= $scope.selectionLimit) {
              var item = self.queries.splice(0, 1);
              delete self.queryIds[item._id];
            }
          }
          var decendentOf = self.lineage.isDecendent($tag._id, self.queries);
          if (decendentOf) {
            $translate('workflowCategorySelection.already_covered_by', {type: $scope.type, name: decendentOf.name }).then(function (translation) {
              Application.messaging.addMessage({text: translation, duration: 7});
              return false;
            });
          }
          var ancestorOf = self.lineage.isAncestor($tag._id, self.queries);
          if (ancestorOf) {
            $translate('workflowCategorySelection.following_now_covered', {type:$scope.type, name:$tag.name }).then(function (translation) {
              message = translation;

              var names = [];
              for (var i = 0; i < ancestorOf.length; i++) {
                covered[ancestorOf[i]] = true;
              }
              for (var i = self.queries.length - 1; i >= 0; i--) {
                if (covered[self.queries[i]._id]) {
                  var item = self.queries.splice(i, 1)[0];
                  delete self.queryIds[item._id];
                  names.push(item.name);
                }
              }
              names = names.join(', ');
              Application.messaging.addMessage({text: message + names, duration: 7});
            });
          }
          return true;
        },
        addedTag: function ($tag, outside) {
          self.queryIds[$tag._id] = true;
          self.updateQuery();
        },
        removedTag: function ($tag) {
          delete self.queryIds[$tag._id];
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          self.queryIds = {};
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.lineageName = function (item) {
        let name = item.name || '';

        if (item.parent && item.parent.name) {
          name = item.parent.name + ' -> ' + name;
          if (item.parent.parent && item.parent.parent.name) {
            name = item.parent.parent.name + ' -> ' + name;
          }
        }

        return name;
      };

      self.getOptions = function (input) {
        if (!initClosed) {
          initClosed++;
          initWatch();
        }
        var items = [];
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';

        let promise, query;
        if ($scope.type === 'group') {
          query = {
            fields: 'location,department,team,org_level,grade,name,localized_names',
            sort: 'name,1',
            page: 1,
            per_page: 30,
            name: '$regex,2,' + input + ',i'
          };

          var ids = Object.keys(self.queryIds);
          if (ids.length) {
            query._id = '$nin,' + ids.length + ',' + ids.join(',');
          }

          promise = Groups.find(query).$promise;
        } else {
          query = {
            page: 1,
            per_page: 500,
            text: input
          };

          query[$scope.type] = true;

          // TODO We might have to preserve this.  Currently the tag input field handles excluding duplicates,
          //   but it does mean we're returning more data than necessary.  Re-evaluate after some production usage.
          // var ids = Object.keys(self.queryIds);
          // if (ids.length) {
          //   query._id = '$nin,' + ids.length + ',' + ids.join(',');
          // }
          promise = Categories.fullTextSearch(query).$promise;
        }

        promise.then(function(results) {
          results.forEach(function(item) {
            self.categories[item._id] = item;
            items.push({
              name: self.lineageName(item),
              text: self.lineageName(item),
              _id: self.categories[item._id]._id,
              type: $scope.type
            });
          });
          deferred.resolve(items);
        }).catch(function(error) {
          console.log('error: ', error)
        });

        return deferred.promise;
      };

      self.initialize = function () {
        var query = {fields: 'location,department,team,org_level,grade,name,localized_names,parent', sort: 'name,1'};
        if ($scope.type !== 'group') {
          query[$scope.type] = true;
        }

        var startItems = $scope.startItems || [];
        var ids = startItems.map(function(item) {return item.id || ''});
        self.categories = {};

        if (!ids.length) {
          return;
        }

        query._id = '$in,' + ids.length + ',' + ids.join(',');
        var promise;

        if ($scope.type === 'group') {
          promise = Groups.find(query).$promise;
        } else {
          query.populateLineage = true;
          promise = Categories.find(query).$promise;
        }

        promise.then(function(items) {
          for (var i = 0; i < items.length; i++) {
            self.categories[items[i]._id] = items[i];
          }

          self.given.parse();
        });
      };

      var initClosed = 0;
      var initWatch = $scope.$watch('startItems', function(newVal, oldVal) {
        if (newVal) {
          if (self.categories) {
            self.given.parse();
          }
          initWatch();
        }
      });
      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.tagInput.clear(true);
          $scope.clear = false;
        }
      });
      self.initialize();

      $translate('workflowCategorySelection.search_type', {type: $scope.type }).then(function (translation) {
        self.translations['type_placeholder'] = translation;
      });

    }],
    controllerAs: 'search'
  };
}]);
